module.exports = __webpack_public_path__ + "static/media/w-icon.f2cb44d8.svg";